<template>
  <!-- 通用 UI 线性图标:stroke=currentColor,默认中性 var(--vk-t2)(去蓝→中性,铁律⑤);
       需要品牌色处由父级 color 覆盖即可。取代散落的浅蓝灰 PNG 图标。 -->
  <svg
    class="vk-ui-icon"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.7"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <!-- mail 邮件/信箱 -->
    <g v-if="name === 'mail'">
      <rect x="3" y="5" width="18" height="14" rx="2.5" />
      <path d="M3.5 7 12 13l8.5-6" />
    </g>
    <!-- globe 语言/地球 -->
    <g v-else-if="name === 'globe'">
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18" />
      <path d="M12 3c2.5 2.4 3.8 5.6 3.8 9S14.5 18.6 12 21C9.5 18.6 8.2 15.4 8.2 12S9.5 5.4 12 3Z" />
    </g>
    <!-- heart 收藏 -->
    <g v-else-if="name === 'heart'">
      <path d="M12 20s-7-4.4-9.2-9C1.4 8.3 2.7 5.3 5.6 5c1.9-.2 3.3.9 4.4 2.3C11.1 5.9 12.5 4.8 14.4 5c2.9.3 4.2 3.3 2.8 6-2.2 4.6-9.2 9-9.2 9Z" />
    </g>
    <!-- help 帮助/FAQ -->
    <g v-else-if="name === 'help'">
      <circle cx="12" cy="12" r="9" />
      <path d="M9.2 9.3a2.8 2.8 0 0 1 5.4 1c0 1.9-2.6 2.3-2.6 4" />
      <circle cx="12" cy="17" r="0.6" fill="currentColor" stroke="none" />
    </g>
    <!-- headset 在线客服 -->
    <g v-else-if="name === 'headset'">
      <path d="M4 13v-1a8 8 0 0 1 16 0v1" />
      <rect x="2.5" y="13" width="4" height="6" rx="1.6" />
      <rect x="17.5" y="13" width="4" height="6" rx="1.6" />
      <path d="M20 19a4 4 0 0 1-4 3.2h-2.5" />
    </g>
    <!-- ticket 现金券/优惠券 -->
    <g v-else-if="name === 'ticket'">
      <path d="M3 8.5A1.5 1.5 0 0 1 4.5 7h15A1.5 1.5 0 0 1 21 8.5v2a2 2 0 0 0 0 3v2a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 15.5v-2a2 2 0 0 0 0-3v-2Z" />
      <path d="M14 7v10" stroke-dasharray="1.5 2" />
    </g>
    <!-- handshake 商务合作 -->
    <g v-else-if="name === 'handshake'">
      <path d="M2.5 10.5 6 7.5l3.5.8 2.5 1.7 2.5-1.7 3.5-.8 3.5 3" />
      <path d="M12 10l-2.4 2.3a1.3 1.3 0 0 0 1.8 1.9l.6-.6.9.9a1.3 1.3 0 0 0 1.9-1.8" />
      <path d="M3 11v4l2.5 2 1.7-1.6M21 11v4l-2.5 2" />
    </g>
    <!-- bank 银行卡 -->
    <g v-else-if="name === 'bank'">
      <rect x="2.5" y="5.5" width="19" height="13" rx="2.5" />
      <path d="M2.5 9.5h19" />
      <path d="M6 14.5h4" />
    </g>
    <!-- dollar 金额/余额 -->
    <g v-else-if="name === 'dollar'">
      <circle cx="12" cy="12" r="9" />
      <path d="M14.5 9.2A3 3 0 0 0 12 8c-1.7 0-3 1-3 2.3 0 3 6 1.4 6 4.4 0 1.3-1.3 2.3-3 2.3a3 3 0 0 1-2.5-1.2" />
      <path d="M12 6.3v1.7M12 16v1.7" />
    </g>
    <!-- withdraw 提现/出金 -->
    <g v-else-if="name === 'withdraw'">
      <rect x="2.5" y="6.5" width="19" height="11" rx="2.5" />
      <circle cx="12" cy="12" r="2.4" />
      <path d="M12 3v3.5M10.3 5 12 6.6 13.7 5" />
    </g>
    <!-- wallet 钱包/金额 -->
    <g v-else-if="name === 'wallet'">
      <path d="M3 8a2 2 0 0 1 2-2h12.5A1.5 1.5 0 0 1 19 7.5V8" />
      <rect x="3" y="7.5" width="18" height="11" rx="2.5" />
      <circle cx="16.8" cy="13" r="1.3" fill="currentColor" stroke="none" />
    </g>
    <!-- info 提示/注意(!) -->
    <g v-else-if="name === 'info'">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7.6v6" />
      <circle cx="12" cy="16.6" r="0.7" fill="currentColor" stroke="none" />
    </g>
    <!-- refresh 刷新/重置 -->
    <g v-else-if="name === 'refresh'">
      <path d="M20 11a8 8 0 0 0-14-4.6L4 9" />
      <path d="M4 13a8 8 0 0 0 14 4.6L20 15" />
      <path d="M4 4.5V9h4.5M20 19.5V15h-4.5" />
    </g>
    <!-- 默认:小圆点 -->
    <circle v-else cx="12" cy="12" r="2.4" fill="currentColor" stroke="none" />
  </svg>
</template>

<script>
export default {
  name: 'UiIcon',
  props: {
    name: { type: String, required: true },
    size: { type: [Number, String], default: 18 }
  }
}
</script>

<style lang="less" scoped>
.vk-ui-icon {
  color: var(--vk-t2); /* 默认中性灰;父级设 color 可改品牌色 */
  display: inline-block;
  vertical-align: middle;
  flex: none;
}
</style>
